/* globals navigator, DedicatedWorkerGlobalScope */
// @flow

const isReactNative = typeof navigator === 'object' && navigator.product === 'ReactNative';

export const hasReactNativeRemoteJSDev =
  isReactNative && typeof DedicatedWorkerGlobalScope !== 'undefined';

export default isReactNative;
